import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { supabase } from '@/lib/supabase'

const QUICK = [
  'Isometrics done today? Lock in. 💪',
  'Get your stretching in before bed.',
  'Session time — let’s go. See you in the gym.',
  'Recovery matters. Sleep + mobility tonight.',
]

/** Coach control: fire a push nudge to the whole squad via /api/send-push. */
export function SendNudge() {
  const [open, setOpen] = useState(false)
  const [msg, setMsg] = useState('')
  const [status, setStatus] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const send = async () => {
    const body = msg.trim()
    if (!body) return
    setBusy(true)
    setStatus(null)
    try {
      const { data } = await supabase.auth.getSession()
      const token = data.session?.access_token
      const res = await fetch('/api/send-push', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ all: true, body }),
      })
      const json = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(json.error || 'Send failed')
      setStatus(`Sent to ${json.sent ?? 0} device${json.sent === 1 ? '' : 's'}.`)
      setMsg('')
    } catch (e) {
      setStatus((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>
        📣 Send Nudge
      </Button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={() => setOpen(false)}>
          <div
            className="w-full max-w-md rounded-card border border-border bg-surface p-5 shadow-card-hover animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="font-display text-2xl tracking-wide">Send a Nudge</h2>
            <p className="mt-0.5 text-sm text-muted">Push notification to every athlete with the app.</p>

            <textarea
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              placeholder="Type your message…"
              className="mt-4 h-24 w-full resize-none rounded-input border border-border-strong bg-white/[.03] p-3 text-[15px] text-text outline-none placeholder:text-subtle focus:border-gold focus:ring-2 focus:ring-gold/25"
            />

            <div className="mt-2 flex flex-wrap gap-1.5">
              {QUICK.map((q) => (
                <button
                  key={q}
                  onClick={() => setMsg(q)}
                  className="rounded-full border border-border bg-surface-2 px-2.5 py-1 text-xs text-muted hover:border-gold/50 hover:text-gold"
                >
                  {q.length > 28 ? q.slice(0, 26) + '…' : q}
                </button>
              ))}
            </div>

            {status && <p className="mt-3 text-sm text-data">{status}</p>}

            <div className="mt-5 flex gap-2">
              <Button variant="secondary" onClick={() => setOpen(false)}>Close</Button>
              <Button className="flex-1" disabled={!msg.trim() || busy} onClick={send}>
                {busy ? 'Sending…' : 'Send to Squad'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
